import React from "react";
import cx from "classnames";

const Radio = ({ label, name, className }) => (
  <div className={cx("radio", className)}>
    <input type="radio" name={name} />
    <label className="mb-0 ml-1">{label}</label>
  </div>
);

export default Radio;
